import { Injectable } from '@angular/core';

@Injectable()
export class DummySettingsService {
  public getSpotoviSettings() {
    return [
      {
        title: 'Spotovi',
        group: 'Spotovi',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF6',
        idProperty: 'id',
        completerMainField: 'id',
        completerSecondField: 'brojCenovnika',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: true,
        filterFields: [
          {
            id: '111111111',
            name: 'naziv',
            fieldKey: 'naziv',
            label: 'Naziv',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'potovi',
            width: 50,
            dbType: 'VARCHAR(100)',
            default: true,
          },
          {
            id: '222222222',
            name: 'kupac',
            fieldKey: 'kupac',
            label: 'Kupac',
            height: 3,
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(100)',
            default: true,
          },
          {
            id: '333333333',
            name: 'datumPrijema',
            fieldKey: 'datumPrijema',
            label: 'Datum Prijema',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Spotovi',
            width: 10,
            dbType: 'DATE',
            default: false,
          },
          {
            id: '444444444',
            name: 'vrstaZabrane',
            fieldKey: 'vrstaZabrane',
            label: 'Vrsta zabrane',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Spotovi',
            width: 10,
            dbType: 'VARCHAR(100)',
            default: false,
          },
        ],
        allFields: [
          {
            id: '111111111',
            name: 'naziv',
            fieldKey: 'naziv',
            label: 'Naziv',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'potovi',
            width: 50,
            dbType: 'VARCHAR(100)',
            default: true,
          },
          {
            id: '222222222',
            name: 'kupac',
            fieldKey: 'kupac',
            label: 'Kupac',
            height: 3,
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(100)',
            default: true,
          },
          {
            id: '333333333',
            name: 'datumPrijema',
            fieldKey: 'datumPrijema',
            label: 'Datum Prijema',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Spotovi',
            width: 10,
            dbType: 'DATE',
            default: true,
          },
          {
            id: '444444444',
            name: 'vrstaZabrane',
            fieldKey: 'vrstaZabrane',
            label: 'Vrsta zabrane',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Spotovi',
            width: 10,
            dbType: 'VARCHAR(100)',
            default: true,
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [
                    ['111111111', '222222222', '333333333'],
                    ['444444444'],
                  ],
                },
              ],
            },
          ],
          table: ['111111111', '222222222', '333333333', '444444444'],
          lookupTable: ['111111111', '222222222', '333333333', '444444444'],
        },
        relations: [],
        details: [
          {
            title: 'Spotovi',
            group: 'Spotovi',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'id',
            completerSecondField: 'brojCenovnika',
            completerMainAndSecond: true,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            filterFields: [],
            allFields: [],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [['1668898846'], []],
                    },
                  ],
                },
              ],
              table: ['1668898846'],
              lookupTable: ['1668898846'],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }

  getCenovniciSettings() {
    return [
      {
        title: 'Cenovnici',
        group: 'Cenovnici',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF5',
        idProperty: 'id',
        completerMainField: 'id',
        completerSecondField: 'brojCenovnika',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: true,
        filterFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Cenovnici',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
          {
            id: '222222222',
            name: 'brojCenovnika',
            fieldKey: 'brojCenovnika',
            label: 'Broj cenovnika',
            type: 'input',
            javaFieldType: 'java.lang.Integer',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 5,
            dbType: 'INTEGER',
            default: false,
          },
          {
            id: '333333333',
            name: 'nazivCenovnika',
            fieldKey: 'nazivCenovnika',
            label: 'Naziv cenovnika',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '444444444',
            name: 'opis',
            fieldKey: 'opis',
            label: 'Opis',
            height: 3,
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '5555555555',
            name: 'datumPocetkaVazenja',
            fieldKey: 'datumPocetkaVazenja',
            label: 'Datum pocetka vazenja',
            type: 'date',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 120,
            dbType: 'DATE',
            default: false,
          },
          {
            id: '66666666666',
            name: 'datumKrajaVazenja',
            fieldKey: 'datumKrajaVazenja',
            label: 'Datum kraja vazenja',
            type: 'date',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 120,
            dbType: 'DATE',
          },
        ],
        allFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Cenovnici',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
          {
            id: '222222222',
            name: 'brojCenovnika',
            fieldKey: 'brojCenovnika',
            label: 'Broj cenovnika',
            type: 'input',
            javaFieldType: 'java.lang.Integer',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 5,
            dbType: 'INTEGER',
            default: false,
          },
          {
            id: '333333333',
            name: 'nazivCenovnika',
            fieldKey: 'nazivCenovnika',
            label: 'Naziv cenovnika',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '444444444',
            name: 'opis',
            fieldKey: 'opis',
            height: 3,
            multiline: true,
            label: 'Opis',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '5555555555',
            name: 'datumPocetkaVazenja',
            fieldKey: 'datumPocetkaVazenja',
            label: 'Datum pocetka vazenja',
            type: 'date',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 120,
            dbType: 'DATE',
            default: false,
          },
          {
            id: '66666666666',
            name: 'datumKrajaVazenja',
            fieldKey: 'datumKrajaVazenja',
            label: 'Datum kraja vazenja',
            type: 'date',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 120,
            dbType: 'DATE',
          },
          {
            id: '7777777777',
            name: 'isActive',
            fieldKey: 'isActive',
            label: 'Aktivan',
            entityType: 'DalJeAktivan',
            type: 'comboFixed',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Cenovnici',
            width: 120,
            dbType: 'VARCHAR(30)',
          },
          {
            id: '8888888888',
            name: 'datumBrisanja',
            fieldKey: 'datumBrisanja',
            label: 'Datum brisanja',
            type: 'date',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Cenovnici',
            width: 120,
            dbType: 'VARCHAR(30)',
          },
          {
            id: '99999999999',
            name: 'korisnikKojiJeObrisao',
            fieldKey: 'korisnikKojiJeObrisao',
            label: 'Korisnik koji je obrisao',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Cenovnici',
            width: 120,
            dbType: 'VARCHAR(30)',
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [
                    [
                      '111111111',
                      '222222222',
                      '333333333',
                      '5555555555',
                      '66666666666',
                    ],
                    ['7777777777', '8888888888', '99999999999', '444444444'],
                  ],
                },
              ],
            },
          ],
          table: [
            '111111111',
            '222222222',
            '444444444',
            '333333333',
            '5555555555',
            '66666666666',
            '7777777777',
          ],
          lookupTable: [
            '111111111',
            '222222222',
            '333333333',
            '444444444',
            '5555555555',
            '66666666666',
            '7777777777',
          ],
        },
        relations: [],
        details: [
          {
            title: 'Korisnici',
            group: 'Cenovnici',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'id',
            completerSecondField: 'brojCenovnika',
            completerMainAndSecond: true,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            filterFields: [
              {
                id: '1668898846',
                name: 'id',
                entityType: 'id',
                label: 'ID',
                type: 'completer',
                javaFieldType: 'id',
                editable: true,
                additable: true,
                mandatory: false,
                path: 'Cenovnici',
                width: 92,
                dbType: 'BIGINT',
                default: false,
              },
            ],
            allFields: [
              {
                id: '111111111',
                name: 'id',
                fieldKey: 'id',
                label: 'ID',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: false,
                additable: false,
                mandatory: false,
                path: 'Cenovnici',
                width: 10,
                dbType: 'VARCHAR(26)',
                default: false,
              },
              {
                id: '222222222',
                name: 'brojCenovnika',
                fieldKey: 'brojCenovnika',
                label: 'Broj cenovnika',
                type: 'input',
                javaFieldType: 'java.lang.Integer',
                editable: true,
                additable: true,
                mandatory: true,
                path: 'Cenovnici',
                width: 5,
                dbType: 'INTEGER',
                default: false,
              },
              {
                id: '333333333',
                name: 'nazivCenovnika',
                fieldKey: 'nazivCenovnika',
                label: 'Naziv cenovnika',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: true,
                path: 'Cenovnici',
                width: 50,
                dbType: 'VARCHAR(300)',
                default: false,
              },
              {
                id: '444444444',
                name: 'opis',
                fieldKey: 'opis',
                label: 'Opis',
                height: 3,
                type: 'input',
                multiline: true,
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: false,
                path: 'Users',
                width: 50,
                dbType: 'VARCHAR(300)',
                default: false,
              },
              {
                id: '5555555555',
                name: 'datumPocetkaVazenja',
                fieldKey: 'datumPocetkaVazenja',
                label: 'Datum pocetka vazenja',
                type: 'date',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: true,
                path: 'Cenovnici',
                width: 120,
                dbType: 'DATE',
                default: false,
              },
              {
                id: '66666666666',
                name: 'datumKrajaVazenja',
                fieldKey: 'datumKrajaVazenja',
                label: 'Datum kraja vazenja',
                type: 'date',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: true,
                path: 'Cenovnici',
                width: 120,
                dbType: 'DATE',
              },
              {
                id: '7777777777',
                name: 'isActive',
                fieldKey: 'isActive',
                label: 'Aktivan',
                entityType: 'DalJeAktivan',
                type: 'comboFixed',
                javaFieldType: 'java.lang.String',
                editable: false,
                additable: false,
                mandatory: false,
                path: 'Cenovnici',
                width: 120,
                dbType: 'VARCHAR(30)',
              },
              {
                id: '8888888888',
                name: 'datumBrisanja',
                fieldKey: 'datumBrisanja',
                label: 'Datum brisanja',
                type: 'date',
                javaFieldType: 'java.lang.String',
                editable: false,
                additable: false,
                mandatory: false,
                path: 'Cenovnici',
                width: 120,
                dbType: 'VARCHAR(30)',
              },
              {
                id: '99999999999',
                name: 'korisnikKojiJeObrisao',
                fieldKey: 'korisnikKojiJeObrisao',
                label: 'Korisnik koji je obrisao',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: false,
                additable: false,
                mandatory: false,
                path: 'Cenovnici',
                width: 120,
                dbType: 'VARCHAR(30)',
              },
            ],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [['1668898846'], []],
                    },
                  ],
                },
              ],
              table: ['1668898846'],
              lookupTable: ['1668898846'],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }

  getNacinEmitovanjaSettings() {
    return [
      {
        title: 'Nacin emitivanja',
        group: 'NacinEmitovanja',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF5',
        idProperty: 'id',
        completerMainField: 'id',
        completerSecondField: 'brojCenovnika',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: true,
        filterFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Cenovnici',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
          {
            id: '333333333',
            name: 'naziv',
            fieldKey: 'naziv',
            label: 'Naziv',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '444444444',
            name: 'opis',
            fieldKey: 'opis',
            label: 'Opis',
            height: 3,
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
        ],
        allFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Cenovnici',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
          {
            id: '333333333',
            name: 'naziv',
            fieldKey: 'naziv',
            label: 'Naziv',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '444444444',
            name: 'opis',
            fieldKey: 'opis',
            height: 3,
            multiline: true,
            label: 'Opis',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [['111111111', '333333333', '444444444'], []],
                },
              ],
            },
          ],
          table: ['111111111', '333333333', '444444444'],
          lookupTable: ['111111111', '333333333', '444444444'],
        },
        relations: [],
        details: [
          {
            title: 'NacinEmitovanja',
            group: 'NacinEmitovanja',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'id',
            completerSecondField: 'brojCenovnika',
            completerMainAndSecond: true,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            filterFields: [
              {
                id: '1668898846',
                name: 'id',
                entityType: 'id',
                label: 'ID',
                type: 'completer',
                javaFieldType: 'id',
                editable: true,
                additable: true,
                mandatory: false,
                path: 'Cenovnici',
                width: 92,
                dbType: 'BIGINT',
                default: false,
              },
            ],
            allFields: [
              {
                id: '111111111',
                name: 'id',
                fieldKey: 'id',
                label: 'ID',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: false,
                additable: false,
                mandatory: false,
                path: 'Cenovnici',
                width: 10,
                dbType: 'VARCHAR(26)',
                default: false,
              },
              {
                id: '333333333',
                name: 'naziv',
                fieldKey: 'naziv',
                label: 'Naziv',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: true,
                path: 'Cenovnici',
                width: 50,
                dbType: 'VARCHAR(300)',
                default: false,
              },
              {
                id: '444444444',
                name: 'opis',
                fieldKey: 'opis',
                label: 'Opis',
                height: 3,
                type: 'input',
                multiline: true,
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: false,
                path: 'Users',
                width: 50,
                dbType: 'VARCHAR(300)',
                default: false,
              },
            ],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [['1668898846'], []],
                    },
                  ],
                },
              ],
              table: ['1668898846'],
              lookupTable: ['1668898846'],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }

  getPopustiUvecanjaSettings() {
    return [
      {
        title: 'Popusti i uvecanja',
        group: 'PopustiIUvecanja',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF5',
        idProperty: 'id',
        completerMainField: 'id',
        completerSecondField: 'brojCenovnika',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: true,
        filterFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Cenovnici',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
          {
            id: '333333333',
            name: 'naziv',
            fieldKey: 'naziv',
            label: 'Naziv',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '566666666',
            name: 'iznos',
            fieldKey: 'iznos',
            label: 'Iznos',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
        ],
        allFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Cenovnici',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
          {
            id: '333333333',
            name: 'naziv',
            fieldKey: 'naziv',
            label: 'Naziv',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '566666666',
            name: 'iznos',
            fieldKey: 'iznos',
            label: 'Iznos',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '444444444',
            name: 'opis',
            fieldKey: 'opis',
            height: 3,
            multiline: true,
            label: 'Opis',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '566623366666',
            name: 'izvrsilac',
            fieldKey: 'izvrsilac',
            label: 'Izvršilac',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '51266666666',
            name: 'datumOd',
            fieldKey: 'datumOd',
            label: 'Datum od',
            type: 'date',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'Date',
            default: false,
          },
          {
            id: '5126336666',
            name: 'datumDo',
            fieldKey: 'datumDo',
            label: 'Datum do',
            type: 'date',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'Date',
            default: false,
          },
          {
            id: '566623366166',
            name: 'status',
            fieldKey: 'status',
            label: 'Status',
            entitiyType: 'DalJeAktivan',
            type: 'comboFixed',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [
                    [
                      '111111111',
                      '333333333',
                      '566666666',
                      '444444444',
                      '566623366666',
                    ],
                    ['51266666666', '5126336666', '566623366166'],
                  ],
                },
              ],
            },
          ],
          table: ['111111111', '333333333', '566666666'],
          lookupTable: ['111111111', '333333333', '566666666'],
        },
        relations: [],
        details: [
          {
            title: 'NacinEmitovanja',
            group: 'NacinEmitovanja',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'id',
            completerSecondField: 'brojCenovnika',
            completerMainAndSecond: true,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            filterFields: [
              {
                id: '1668898846',
                name: 'id',
                entityType: 'id',
                label: 'ID',
                type: 'completer',
                javaFieldType: 'id',
                editable: true,
                additable: true,
                mandatory: false,
                path: 'Cenovnici',
                width: 92,
                dbType: 'BIGINT',
                default: false,
              },
            ],
            allFields: [
              {
                id: '111111111',
                name: 'id',
                fieldKey: 'id',
                label: 'ID',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: false,
                additable: false,
                mandatory: false,
                path: 'Cenovnici',
                width: 10,
                dbType: 'VARCHAR(26)',
                default: false,
              },
              {
                id: '333333333',
                name: 'naziv',
                fieldKey: 'naziv',
                label: 'Naziv',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: true,
                path: 'Cenovnici',
                width: 50,
                dbType: 'VARCHAR(300)',
                default: false,
              },
              {
                id: '566666666',
                name: 'iznos',
                fieldKey: 'iznos',
                label: 'Iznos',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: false,
                path: 'Users',
                width: 50,
                dbType: 'VARCHAR(300)',
                default: false,
              },
              {
                id: '444444444',
                name: 'opis',
                fieldKey: 'opis',
                height: 3,
                multiline: true,
                label: 'Opis',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: false,
                path: 'Users',
                width: 50,
                dbType: 'VARCHAR(300)',
                default: false,
              },
              {
                id: '566623366666',
                name: 'izvrsilac',
                fieldKey: 'izvrsilac',
                label: 'Izvršilac',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: false,
                path: 'Users',
                width: 50,
                dbType: 'VARCHAR(300)',
                default: false,
              },
              {
                id: '51266666666',
                name: 'datumOd',
                fieldKey: 'datumOd',
                label: 'Datum od',
                type: 'date',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: false,
                path: 'Users',
                width: 50,
                dbType: 'Date',
                default: false,
              },
              {
                id: '5126336666',
                name: 'datumDo',
                fieldKey: 'datumDo',
                label: 'Datum do',
                type: 'date',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: false,
                path: 'Users',
                width: 50,
                dbType: 'Date',
                default: false,
              },
              {
                id: '566623366166',
                name: 'status',
                fieldKey: 'status',
                label: 'Status',
                entitiyType: 'DalJeAktivan',
                type: 'comboFixed',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: false,
                path: 'Users',
                width: 50,
                dbType: 'VARCHAR(300)',
                default: false,
              },
            ],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [['1668898846'], []],
                    },
                  ],
                },
              ],
              table: ['1668898846'],
              lookupTable: ['1668898846'],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }

  getUcestalostEmitovanjaSettings() {
    return [
      {
        title: 'Nacin emitivanja',
        group: 'NacinEmitovanja',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF5',
        idProperty: 'id',
        completerMainField: 'id',
        completerSecondField: 'brojCenovnika',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: true,
        filterFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Cenovnici',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
          {
            id: '333333333',
            name: 'naziv',
            fieldKey: 'naziv',
            label: 'Naziv',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '444444444',
            name: 'opis',
            fieldKey: 'opis',
            label: 'Opis',
            height: 3,
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
        ],
        allFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Cenovnici',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
          {
            id: '333333333',
            name: 'naziv',
            fieldKey: 'naziv',
            label: 'Naziv',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '444444444',
            name: 'opis',
            fieldKey: 'opis',
            height: 3,
            multiline: true,
            label: 'Opis',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [['111111111', '333333333', '444444444'], []],
                },
              ],
            },
          ],
          table: ['111111111', '333333333', '444444444'],
          lookupTable: ['111111111', '333333333', '444444444'],
        },
        relations: [],
        details: [
          {
            title: 'NacinEmitovanja',
            group: 'NacinEmitovanja',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'id',
            completerSecondField: 'brojCenovnika',
            completerMainAndSecond: true,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            filterFields: [
              {
                id: '1668898846',
                name: 'id',
                entityType: 'id',
                label: 'ID',
                type: 'completer',
                javaFieldType: 'id',
                editable: true,
                additable: true,
                mandatory: false,
                path: 'Cenovnici',
                width: 92,
                dbType: 'BIGINT',
                default: false,
              },
            ],
            allFields: [
              {
                id: '111111111',
                name: 'id',
                fieldKey: 'id',
                label: 'ID',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: false,
                additable: false,
                mandatory: false,
                path: 'Cenovnici',
                width: 10,
                dbType: 'VARCHAR(26)',
                default: false,
              },
              {
                id: '333333333',
                name: 'naziv',
                fieldKey: 'naziv',
                label: 'Naziv',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: true,
                path: 'Cenovnici',
                width: 50,
                dbType: 'VARCHAR(300)',
                default: false,
              },
              {
                id: '444444444',
                name: 'opis',
                fieldKey: 'opis',
                label: 'Opis',
                height: 3,
                type: 'input',
                multiline: true,
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: false,
                path: 'Users',
                width: 50,
                dbType: 'VARCHAR(300)',
                default: false,
              },
            ],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [['1668898846'], []],
                    },
                  ],
                },
              ],
              table: ['1668898846'],
              lookupTable: ['1668898846'],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }

  getVrstaZabraneSettings() {
    return [
      {
        title: 'Vrsta zabrane',
        group: 'VrstaZabrane',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF5',
        idProperty: 'id',
        completerMainField: 'id',
        completerSecondField: 'brojCenovnika',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: true,
        filterFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Cenovnici',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
          {
            id: '333333333',
            name: 'naziv',
            fieldKey: 'naziv',
            label: 'Naziv',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
        ],
        allFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Cenovnici',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
          {
            id: '333333333',
            name: 'naziv',
            fieldKey: 'naziv',
            label: 'Naziv',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Cenovnici',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [['111111111', '333333333'], []],
                },
              ],
            },
          ],
          table: ['111111111', '333333333'],
          lookupTable: ['111111111', '333333333'],
        },
        relations: [],
        details: [
          {
            title: 'VrstaZabrane',
            group: 'VrstaZabrane',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'id',
            completerSecondField: 'brojCenovnika',
            completerMainAndSecond: true,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            filterFields: [
              {
                id: '1668898846',
                name: 'id',
                entityType: 'id',
                label: 'ID',
                type: 'completer',
                javaFieldType: 'id',
                editable: true,
                additable: true,
                mandatory: false,
                path: 'VrstaZabrane',
                width: 92,
                dbType: 'BIGINT',
                default: false,
              },
            ],
            allFields: [
              {
                id: '111111111',
                name: 'id',
                fieldKey: 'id',
                label: 'ID',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: false,
                additable: false,
                mandatory: false,
                path: 'VrstaZabrane',
                width: 10,
                dbType: 'VARCHAR(26)',
                default: false,
              },
              {
                id: '333333333',
                name: 'naziv',
                fieldKey: 'naziv',
                label: 'Naziv',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: true,
                path: 'VrstaZabrane',
                width: 50,
                dbType: 'VARCHAR(300)',
                default: false,
              },
            ],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [['1668898846'], []],
                    },
                  ],
                },
              ],
              table: ['1668898846'],
              lookupTable: ['1668898846'],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }

  getCiljneGrupeSettings() {
    return [
      {
        title: 'Ciljne grupe',
        group: 'CiljneGrupe',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF5',
        idProperty: 'id',
        completerMainField: 'sifra',
        completerSecondField: 'naziv',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: true,
        filterFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Users',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
          {
            id: '222222222',
            name: 'nazivCiljneGrupe',
            fieldKey: 'nazivCiljneGrupe',
            label: 'Naziv ciljne grupe',
            type: 'input',
            javaFieldType: 'java.lang.Integer',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Users',
            width: 5,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '333333333',
            name: 'opis',
            fieldKey: 'opis',
            label: 'Opis',
            type: 'input',
            multiline: true,
            height: 3,
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '444444444',
            name: 'pol',
            fieldKey: 'pol',
            label: 'Pol',
            entityType: 'PolEnum',
            type: 'comboFixed',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '5555555555',
            fieldKey: 'starostOd',
            name: 'starostOd',
            label: 'Starost od',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 120,
            dbType: 'INTEGER',
            default: false,
          },
          {
            id: '6666666666',
            name: 'starostDo',
            fieldKey: 'starostDo',
            label: 'Starost do',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Users',
            width: 120,
            dbType: 'INTEGER',
            default: false,
          },
        ],
        allFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Users',
            width: 10,
            dbType: 'VARCHAR(26)',
          },
          {
            id: '222222222',
            name: 'nazivCiljneGrupe',
            fieldKey: 'nazivCiljneGrupe',
            label: 'Naziv ciljne grupe',
            type: 'input',
            javaFieldType: 'java.lang.Integer',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Users',
            width: 5,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '333333333',
            name: 'opis',
            fieldKey: 'opis',
            label: 'Opis',
            type: 'input',
            multiline: true,
            height: 3,
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [['111111111', '222222222', '333333333'], []],
                },
              ],
            },
          ],
          table: ['222222222', '333333333'],
          lookupTable: [
            '111111111',
            '444444444',
            '333333333',
            '222222222',
            '5555555555',
            '66666666666',
          ],
        },
        relations: [],
        details: [
          {
            title: 'Ciljne grupe',
            group: 'CiljneGrupe',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'id',
            completerSecondField: 'id',
            completerMainAndSecond: false,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            filterFields: [
              {
                id: '1668898846',
                name: 'id',
                entityType: 'id',
                label: 'ID',
                type: 'completer',
                javaFieldType: 'id',
                editable: true,
                additable: true,
                mandatory: false,
                path: 'Users',
                width: 92,
                dbType: 'BIGINT',
                default: false,
              },
            ],
            allFields: [
              {
                id: '111111111',
                name: 'id',
                fieldKey: 'id',
                label: 'ID',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: false,
                additable: false,
                mandatory: false,
                inlineAdding: true,
                inlineEditing: true,
                path: 'Users',
                width: 10,
                dbType: 'VARCHAR(26)',
              },
              {
                id: '222222222',
                name: 'nazivCiljneGrupe',
                fieldKey: 'nazivCiljneGrupe',
                label: 'Naziv ciljne grupe',
                type: 'input',
                javaFieldType: 'java.lang.Integer',
                editable: true,
                additable: true,
                mandatory: true,
                inlineAdding: true,
                inlineEditing: true,
                path: 'Users',
                width: 5,
                dbType: 'VARCHAR(300)',
              },
              {
                id: '333333333',
                name: 'opis',
                fieldKey: 'opis',
                label: 'Opis',
                type: 'input',
                multiline: true,
                height: 3,
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: false,
                inlineAdding: true,
                inlineEditing: true,
                path: 'Users',
                width: 50,
                dbType: 'VARCHAR(300)',
              },
              {
                id: '444444444',
                name: 'pol',
                fieldKey: 'pol',
                label: 'Pol',
                entityType: 'PolEnum',
                type: 'comboFixed',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: true,
                inlineAdding: true,
                inlineEditing: true,
                path: 'Users',
                width: 50,
                dbType: 'VARCHAR(300)',
              },
              {
                id: '5555555555',
                name: 'starostOd',
                fieldKey: 'starostOd',
                label: 'Starost od',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: true,
                inlineAdding: true,
                inlineEditing: true,
                path: 'Users',
                width: 120,
                dbType: 'INTEGER',
              },
              {
                id: '6666666666',
                name: 'starostDo',
                fieldKey: 'starostDo',
                label: 'Starost do',
                type: 'input',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: true,
                inlineAdding: true,
                inlineEditing: true,
                path: 'Users',
                width: 120,
                dbType: 'INTEGER',
              },
            ],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [['111111111', '222222222', '333333333'], []],
                    },
                  ],
                },
              ],
              table: ['7777777777', '444444444', '5555555555', '6666666666'],
              lookupTable: ['1668898846'],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }

  getAdministracijaKorsinikaSettings() {
    return [
      {
        title: 'Korisnici',
        group: 'Korisnici',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF5',
        idProperty: 'id',
        completerMainField: 'sifra',
        completerSecondField: 'naziv',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: false,
        filterFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
          {
            id: '222222222',
            name: 'rbr',
            fieldKey: 'rbr',
            label: 'Rbr',
            type: 'input',
            javaFieldType: 'java.lang.Integer',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 5,
            dbType: 'INTEGER',
            default: false,
          },
          {
            id: '333333333',
            name: 'ime',
            fieldKey: 'ime',
            label: 'Ime',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '444444444',
            name: 'prezime',
            fieldKey: 'prezime',
            label: 'Prezime',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '5555555555',
            name: 'uloga',
            fieldKey: 'uloga',
            label: 'Uloga',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 120,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '66666666666',
            name: 'email',
            fieldKey: 'email',
            label: 'e-mail',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 120,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '777777777777',
            name: 'sektor',
            fieldKey: 'sektor',
            label: 'Sektor',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 120,
            dbType: 'VARCHAR(300)',
            default: false,
          },
          {
            id: '8888888888',
            name: 'telefon',
            fieldKey: 'telefon',
            label: 'Telefon',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 120,
            dbType: 'VARCHAR(300)',
            default: false,
          },
        ],
        allFields: [
          {
            id: '111111111',
            name: 'Id',
            fieldKey: 'Id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.Long',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Users',
            width: 10,
            dbType: 'BIGINT',
          },
          {
            id: '222222222',
            name: 'rbr',
            fieldKey: 'rbr',
            label: 'Rbr',
            type: 'input',
            javaFieldType: 'java.lang.Integer',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 5,
            dbType: 'INTEGER',
          },
          {
            id: '333333333',
            name: 'Ime',
            fieldKey: 'Ime',
            label: 'Ime',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '444444444',
            name: 'Prezime',
            fieldKey: 'Prezime',
            label: 'Prezime',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '66666666666',
            name: 'email',
            fieldKey: 'email',
            label: 'e-mail',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 120,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '777777777777',
            name: 'sektor',
            fieldKey: 'sektor',
            label: 'Sektor',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 120,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '8888888888',
            name: 'telefon',
            fieldKey: 'telefon',
            label: 'Telefon',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'Users',
            width: 120,
            dbType: 'VARCHAR(300)',
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [
                    [
                      //  '222222222',
                      '111111111',
                      '444444444',
                      '333333333',
                      '5555555555',
                      '66666666666',
                      '777777777777',
                      '8888888888',
                    ],
                    [],
                  ],
                },
              ],
            },
          ],
          table: [
            '222222222',
            '111111111',
            '444444444',
            '333333333',
            '5555555555',
          ],
          lookupTable: [
            '111111111',
            '444444444',
            '333333333',
            '222222222',
            '5555555555',
            '66666666666',
          ],
        },
        relations: [],
        details: [
          {
            title: 'Korisnici',
            group: 'Uloge',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'rbr',
            completerSecondField: 'rbr',
            completerMainAndSecond: true,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            allFields: [
              {
                id: '2131233123123',
                name: 'rbr',
                fieldKey: 'rbr',
                label: 'rbr',
                type: 'input',
                javaFieldType: 'java.lang.Long',
                editable: true,
                additable: false,
                mandatory: false,
                path: 'Users',
                width: 20,
                dbType: 'BIGINT',
                default: false,
              },
              {
                id: '123123123123',
                name: 'nazivUloge',
                fieldKey: 'nazivUloge',
                entityType: 'UlogaEnum',
                label: 'Naziv uloge',
                type: 'comboFixed',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: true,
                path: 'Users',
                width: 50,
                dbType: 'INTEGER',
                default: false,
              },
            ],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [['111111111', '333333333'], []],
                    },
                  ],
                },
              ],
              table: ['2131233123123', '123123123123'],
              lookupTable: [],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }

  getOdrzavanjeProgramaSettings() {
    return [
      {
        title: 'Održavanje programa',
        group: 'OdrzavanjePrograma',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF5',
        idProperty: 'id',
        completerMainField: 'sifra',
        completerSecondField: 'naziv',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: false,
        filterFields: [
          {
            id: '222222222',
            name: 'sifra',
            fieldKey: 'sifra',
            label: 'Šifra',
            type: 'input',
            javaFieldType: 'java.lang.Integer',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'OdrzavanjePrograma',
            width: 5,
            dbType: 'INTEGER',
          },
          {
            id: '333333333',
            name: 'nazivPrograma',
            fieldKey: 'nazivPrograma',
            label: 'Naziv programa',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'OdrzavanjePrograma',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '444444444',
            name: 'vrstaMedija',
            fieldKey: 'vrstaMedija',
            label: 'Vrsta medija',
            entityType: 'VrstaMedijaEnum',
            type: 'comboFixed',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'OdrzavanjePrograma',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
        ],
        allFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.Long',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'OdrzavanjePrograma',
            width: 10,
            dbType: 'BIGINT',
          },
          {
            id: '222222222',
            name: 'sifra',
            fieldKey: 'sifra',
            label: 'šifra',
            type: 'input',
            javaFieldType: 'java.lang.Integer',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'OdrzavanjePrograma',
            width: 5,
            dbType: 'INTEGER',
          },
          {
            id: '333333333',
            name: 'nazivPrograma',
            fieldKey: 'nazivPrograma',
            label: 'Naziv programa',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'OdrzavanjePrograma',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '444444444',
            name: 'vrstaMedija',
            fieldKey: 'vrstaMedija',
            label: 'Vrsta medija',
            entityType: 'VrstaMedijaEnum',
            type: 'comboFixed',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'OdrzavanjePrograma',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '12312312312',
            name: 'mestoTroska',
            fieldKey: 'mestoTroska',
            label: 'Mesto troska',
            entityType: 'MestoTroskaEnum',
            type: 'comboFixed',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'OdrzavanjePrograma',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '234234234234',
            name: 'mestoTroska2',
            fieldKey: 'mestoTroska2',
            label: 'Mesto troska 2',
            entityType: 'MestoTroskaEnum',
            type: 'comboFixed',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'OdrzavanjePrograma',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '7777777777',
            name: 'isActive',
            fieldKey: 'isActive',
            label: 'Aktivan',
            entityType: 'DalJeAktivan',
            type: 'comboFixed',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'OdrzavanjePrograma',
            width: 120,
            dbType: 'VARCHAR(30)',
          },
          {
            id: '8888888888',
            name: 'datumBrisanja',
            fieldKey: 'datumBrisanja',
            label: 'Datum brisanja',
            type: 'date',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'OdrzavanjePrograma',
            width: 120,
            dbType: 'DATE',
          },
          {
            id: '99999999999',
            name: 'korisnikKojiJeObrisao',
            fieldKey: 'korisnikKojiJeObrisao',
            label: 'Korisnik koji je obrisao',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'OdrzavanjePrograma',
            width: 120,
            dbType: 'VARCHAR(30)',
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [
                    [
                      '111111111',
                      '222222222',
                      '333333333',
                      '444444444',
                      '12312312312',
                      '234234234234',
                    ],
                    ['7777777777', '8888888888', '99999999999'],
                  ],
                },
              ],
            },
          ],
          table: [
            '111111111',
            '222222222',
            '333333333',
            '444444444',
            '12312312312',
            '234234234234',
          ],
          lookupTable: [
            '111111111',
            '444444444',
            '333333333',
            '222222222',
            '5555555555',
            '66666666666',
          ],
        },
        relations: [],
        details: [
          {
            title: 'Korisnici',
            group: 'OdrzavanjePrograma',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'rbr',
            completerSecondField: 'rbr',
            completerMainAndSecond: true,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            allFields: [
              {
                id: '2131233123123',
                name: 'rbr',
                fieldKey: 'rbr',
                label: 'rbr',
                type: 'input',
                javaFieldType: 'java.lang.Long',
                editable: true,
                additable: false,
                mandatory: false,
                path: 'OdrzavanjePrograma',
                width: 20,
                dbType: 'BIGINT',
                default: false,
              },
              {
                id: '123123123123',
                name: 'nazivUloge',
                fieldKey: 'nazivUloge',
                entityType: 'UlogaEnum',
                label: 'Naziv uloge',
                type: 'comboFixed',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: true,
                path: 'OdrzavanjePrograma',
                width: 50,
                dbType: 'INTEGER',
                default: false,
              },
            ],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [[], []],
                    },
                  ],
                },
              ],
              table: [],
              lookupTable: [],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }

  getEmisijeSettings() {
    return [
      {
        title: 'Emisije',
        group: 'SifarnikEmisija',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF5',
        idProperty: 'id',
        completerMainField: 'sifra',
        completerSecondField: 'naziv',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: false,
        filterFields: [],
        allFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.Long',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'SifarnikEmisija',
            width: 10,
            dbType: 'BIGINT',
          },
          {
            id: '222222222',
            name: 'sifra',
            fieldKey: 'sifra',
            label: 'Šifra',
            type: 'input',
            javaFieldType: 'java.lang.Integer',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'SifarnikEmisija',
            width: 5,
            dbType: 'VARCHAR(50)',
          },
          {
            id: '333333333',
            name: 'nazivEmisije',
            fieldKey: 'nazivEmisije',
            label: 'Naziv emisije',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'SifarnikEmisija',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '123123321412',
            name: 'osnovnaCenaEmisije',
            fieldKey: 'osnovnaCenaEmisije',
            label: 'Osnovna cena emisije (EUR)',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'SifarnikEmisija',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '444444444',
            name: 'dopunskiNaziv',
            fieldKey: 'dopunskiNaziv',
            label: 'Dopunski naziv',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'SifarnikEmisija',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '12312312312',
            name: 'program',
            fieldKey: 'program',
            label: 'Program',
            entityType: 'ProgramEnum',
            type: 'comboFixed',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'SifarnikEmisija',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '23423423324',
            name: 'vremeEmitovanja',
            fieldKey: 'vremeEmitovanja',
            label: 'Vreme emitovanja',
            javaFieldType: 'java.lang.String',
            type: 'input',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'SifarnikEmisija',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '2342342232423',
            name: 'datumPocetkaEmitovanja',
            fieldKey: 'datumPocetkaEmitovanja',
            label: 'Datum pocetka emitovanja',
            javaFieldType: 'java.lang.String',
            type: 'date',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'SifarnikEmisija',
            width: 50,
            dbType: 'DATE',
          },
          {
            id: '23423422324',
            name: 'datumKrajaEmitovanja',
            fieldKey: 'datumKrajaEmitovanja',
            label: 'Datum kraja emitovanja',
            javaFieldType: 'java.lang.String',
            type: 'date',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'SifarnikEmisija',
            width: 50,
            dbType: 'date',
          },
          {
            id: '7777777777',
            name: 'stanje',
            fieldKey: 'stanje',
            label: 'Stanje',
            entityType: 'DalJeAktivan',
            type: 'comboFixed',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'SifarnikEmisija',
            width: 120,
            dbType: 'VARCHAR(30)',
          },
          {
            id: '8888888888',
            name: 'brojDelova',
            fieldKey: 'brojDelova',
            label: 'Broj delova',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'SifarnikEmisija',
            width: 120,
            dbType: 'VARCHAR(40)',
          },
          {
            id: '99999999999',
            name: 'ucestalostEmitovanja',
            fieldKey: 'ucestalostEmitovanja',
            label: 'Ucestalost emitovanja',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'SifarnikEmisija',
            width: 120,
            dbType: 'VARCHAR(30)',
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [
                    [
                      '111111111',
                      '222222222',
                      '123123321412',
                      '333333333',
                      '444444444',
                      '12312312312',
                      '234234234234',
                    ],
                    ['7777777777', '8888888888', '99999999999'],
                  ],
                },
              ],
            },
          ],
          table: [
            '222222222',
            '333333333',
            '12312312312',
            '23423423324',
            '2342342232423',
            '7777777777',
          ],
          lookupTable: [
            '111111111',
            '444444444',
            '333333333',
            '222222222',
            '5555555555',
            '66666666666',
          ],
        },
        relations: [],
        details: [
          {
            title: 'Korisnici',
            group: 'SifarnikEmisija',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'rbr',
            completerSecondField: 'rbr',
            completerMainAndSecond: true,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            allFields: [
              {
                id: '2131233123123',
                name: 'rbr',
                fieldKey: 'rbr',
                label: 'rbr',
                type: 'input',
                javaFieldType: 'java.lang.Long',
                editable: true,
                additable: false,
                mandatory: false,
                path: 'SifarnikEmisija',
                width: 20,
                dbType: 'BIGINT',
                default: false,
              },
              {
                id: '123123123123',
                name: 'nazivUloge',
                fieldKey: 'nazivUloge',
                entityType: 'UlogaEnum',
                label: 'Naziv uloge',
                type: 'comboFixed',
                javaFieldType: 'java.lang.String',
                editable: true,
                additable: true,
                mandatory: true,
                path: 'SifarnikEmisija',
                width: 50,
                dbType: 'INTEGER',
                default: false,
              },
            ],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [[], []],
                    },
                  ],
                },
              ],
              table: [],
              lookupTable: [],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }

  getPregledKupacaSettings() {
    return [
      {
        title: 'Pregled kupaca',
        group: 'PregledKupaca',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF5',
        idProperty: 'id',
        completerMainField: 'id',
        completerSecondField: 'brojCenovnika',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: true,
        filterFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
        ],
        allFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Cenovnici',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
          {
            id: '222222222',
            name: 'vrstaKupca',
            fieldKey: 'vrstaKupca',
            label: 'Vrsta kupca',
            entityType: 'VrstaKupcaEnum',
            type: 'comboFixed',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
          {
            id: '333333333',
            name: 'nazivKupca',
            fieldKey: 'nazivKupca',
            label: 'Naziv kupca',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(26)',
            default: false,
          },
          {
            id: '5555555555',
            name: 'jeAgencija',
            fieldKey: 'jeAgencija',
            label: 'Je agencija',
            type: 'check',
            javaFieldType: 'java.lang.Boolean',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'SMALLINT',
            default: false,
          },
          {
            id: '7777777777',
            name: 'jeOglasivac',
            fieldKey: 'jeOglasivac',
            label: 'Je oglasivac',
            type: 'check',
            javaFieldType: 'java.lang.Boolean',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'SMALLINT',
            default: false,
          },
          {
            id: '8888888888',
            name: 'grad',
            fieldKey: 'grad',
            label: 'Grad',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(40)',
            default: false,
          },
          {
            id: '9999999999',
            name: 'adresa',
            fieldKey: 'adresa',
            label: 'Adresa',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(40)',
            default: false,
          },
          {
            id: '9999999991',
            name: 'pibJmbgVat',
            fieldKey: 'pibJmbgVat',
            label: 'PIB/JMBG/VAT broj',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(100)',
            default: false,
          },
          {
            id: '9999999992',
            name: 'maticniBroj',
            fieldKey: 'maticniBroj',
            label: 'Matični broj',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'INTEGER',
            default: false,
          },
          {
            id: '9999999993',
            name: 'pdv',
            fieldKey: 'pdv',
            label: 'PDV(%)',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'INTEGER',
            default: false,
          },
          {
            id: '9999999994',
            name: 'imeKO',
            fieldKey: 'imeKO',
            label: 'Ime',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(40)',
            default: false,
          },
          {
            id: '9999999995',
            name: 'prezimeKO',
            fieldKey: 'prezimeKO',
            label: 'Prezime',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(40)',
            default: false,
          },
          {
            id: '9999999996',
            name: 'kontaktTelefonKO',
            fieldKey: 'kontaktTelefonKO',
            label: 'Kontakt telefon',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(40)',
            default: false,
          },
          {
            id: '9999999997',
            name: 'emailKO',
            fieldKey: 'emailKO',
            label: 'Adresa elektronske pošte(e-mail)',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(40)',
            default: false,
          },
          {
            id: '9999999998',
            name: 'telefon',
            fieldKey: 'telefon',
            label: 'Telefon',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'INTEGER',
            default: false,
          },
          {
            id: '99999999991',
            name: 'saldoDugovanje',
            fieldKey: 'saldoDugovanje',
            label: 'Saldo dugovanje (din)',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'INTEGER',
            default: false,
          },
          {
            id: '99999999992',
            name: 'saldoPotrazivanje',
            fieldKey: 'saldoPotrazivanje',
            label: 'Saldo potraživanje (din)',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'INTEGER',
            default: false,
          },
          {
            id: '99999999993',
            name: 'kontrolnik',
            fieldKey: 'kontrolnik',
            label: 'Kontrolnik',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(40)',
            default: false,
          },
          {
            id: '99999999994',
            name: 'imeOZ',
            fieldKey: 'imeOZ',
            label: 'Ime',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(40)',
            default: false,
          },
          {
            id: '99999999995',
            name: 'prezimeOZ',
            fieldKey: 'przimeOZ',
            label: 'Prezime',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(40)',
            default: false,
          },
          {
            id: '99999999996',
            name: 'telefonOZ',
            fieldKey: 'telefonOZ',
            label: 'Telefon',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(40)',
            default: false,
          },
          {
            id: '99999999997',
            name: 'emailOZ',
            fieldKey: 'emailOZ',
            label: 'Adresa elektronske pošte(e-mail)',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(40)',
            default: false,
          },
          {
            id: '99999999998',
            name: 'osobaZaduzenaZaKupca',
            fieldKey: 'osobaZaduzenaZaKupca',
            label: 'Osoba zaduzena za kupca',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(40)',
            default: false,
          },
          {
            id: '99999999999',
            name: 'stanje',
            fieldKey: 'stanje',
            label: 'Stanje',
            entityType: 'DalJeAktivan',
            type: 'comboFixed',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: false,
            path: 'PregledKupaca',
            width: 10,
            dbType: 'VARCHAR(40)',
            default: false,
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [
                    [
                      '111111111',
                      '222222222',
                      '333333333',
                      '5555555555',
                      '7777777777',
                      '8888888888',
                      '999999999',
                      '9999999991',
                      '9999999992',
                      '9999999993',
                    ],
                    [
                      '9999999998',
                      '99999999991',
                      '99999999992',
                      '99999999993',
                      '99999999998',
                      '99999999999',
                    ],
                  ],
                },
                {
                  title: 'Kontakt osoba',
                  panelVisible: true,
                  expanded: true,
                  controls: [
                    ['9999999994', '9999999995', '9999999996', '9999999997'],
                    [],
                  ],
                },
                {
                  title: 'Ovlašćeni zastupnik',
                  panelVisible: true,
                  expanded: true,
                  controls: [
                    [
                      '99999999994',
                      '99999999995',
                      '99999999996',
                      '99999999997',
                    ],
                    [],
                  ],
                },
              ],
            },
          ],
          table: [
            '111111111',
            '333333333',
            '9999999991',
            '9999999999',
            '99999999999',
          ],
          lookupTable: ['111111111', '333333333', '444444444'],
        },
        relations: [],
        details: [
          {
            title: 'NacinEmitovanja',
            group: 'NacinEmitovanja',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'id',
            completerSecondField: 'brojCenovnika',
            completerMainAndSecond: true,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            filterFields: [],
            allFields: [],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [['1668898846'], []],
                    },
                  ],
                },
              ],
              table: ['1668898846'],
              lookupTable: ['1668898846'],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }

  getRasporedEmisijaSettings() {
    return [
      {
        title: 'Raspored emisija',
        group: 'RasporedEmisija',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF5',
        idProperty: 'id',
        completerMainField: 'sifra',
        completerSecondField: 'naziv',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: false,
        filterFields: [
          {
            id: '333333333',
            name: 'nazivEmisije',
            fieldKey: 'nazivEmisije',
            label: 'Naziv emisije',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'RasporedEmisija',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '123123321412',
            name: 'cenaEmisijePoRasporedu',
            fieldKey: 'cenaEmisijePoRasporedu',
            label: 'Cena emisije po rasporedu (EUR)',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'RasporedEmisija',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '2342342232423',
            name: 'datumEmitovanja',
            fieldKey: 'datumEmitovanja',
            label: 'Datum emitovanja',
            javaFieldType: 'java.lang.String',
            type: 'date',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'RasporedEmisija',
            width: 50,
            dbType: 'DATE',
          },
        ],
        allFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.Long',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'RasporedEmisija',
            width: 10,
            dbType: 'BIGINT',
          },
          {
            id: '333333333',
            name: 'nazivEmisije',
            fieldKey: 'nazivEmisije',
            label: 'Naziv emisije',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'RasporedEmisija',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '123123321412',
            name: 'cenaEmisijePoRasporedu',
            fieldKey: 'cenaEmisijePoRasporedu',
            label: 'Cena emisije po rasporedu (EUR)',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'RasporedEmisija',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '12312312312',
            name: 'program',
            fieldKey: 'program',
            label: 'Program',
            entityType: 'ProgramEnum',
            type: 'comboFixed',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'RasporedEmisija',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '2342342232423',
            name: 'datumEmitovanja',
            fieldKey: 'datumEmitovanja',
            label: 'Datum emitovanja',
            javaFieldType: 'java.lang.String',
            type: 'date',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'RasporedEmisija',
            width: 50,
            dbType: 'DATE',
          },
          {
            id: '23423422324',
            name: 'vremeEmitovanja',
            fieldKey: 'vremeEmitovanja',
            label: 'Vreme emitovanja',
            javaFieldType: 'java.lang.String',
            type: 'input',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'RasporedEmisija',
            width: 50,
            dbType: 'date',
          },
          {
            id: '8888888888',
            name: 'trajanjeEmisije',
            fieldKey: 'trajanjeEmisije',
            label: 'Trajanje emisije',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'RasporedEmisija',
            width: 120,
            dbType: 'VARCHAR(40)',
          },
          {
            id: '99999999999',
            name: 'raspolozivoVreme',
            fieldKey: 'raspolozivoVreme',
            label: 'Raspoloživo vreme',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'RasporedEmisija',
            width: 120,
            dbType: 'VARCHAR(30)',
          },
          {
            id: '101010101010',
            name: 'utrosenoVreme',
            fieldKey: 'utrosenoVreme',
            label: 'Utrošeno vreme',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'RasporedEmisija',
            width: 120,
            dbType: 'VARCHAR(30)',
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [
                    [
                      '111111111',
                      '333333333',
                      '123123321412',
                      '12312312312',
                      '2342342232423',
                      '23423422324',
                    ],
                    ['8888888888', '99999999999', '101010101010'],
                  ],
                },
              ],
            },
          ],
          table: ['333333333', '23423422324', '2342342232423'],
          lookupTable: [],
        },
        relations: [],
        details: [
          {
            title: 'Korisnici',
            group: 'SifarnikEmisija',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'rbr',
            completerSecondField: 'rbr',
            completerMainAndSecond: true,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            allFields: [],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [[], []],
                    },
                  ],
                },
              ],
              table: [],
              lookupTable: [],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }

  getUgovoriSettings() {
    return [
      {
        title: 'Ugovori',
        group: 'Ugovori',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF5',
        idProperty: 'id',
        completerMainField: 'sifra',
        completerSecondField: 'naziv',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: false,
        filterFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.Long',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Ugovori',
            width: 10,
            dbType: 'BIGINT',
          },
          {
            id: '222222222',
            name: 'sifraUgovora',
            fieldKey: 'sifraUgovora',
            label: 'SifraUgovora',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Ugovori',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '333333333',
            name: 'kupac',
            fieldKey: 'kupac',
            label: 'Kupac',
            type: 'combo',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Ugovori',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '444444444',
            name: 'plasmanac',
            fieldKey: 'plasmanac',
            label: 'Plasmanac',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Ugovori',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '555555555',
            name: 'datumKreiranja',
            fieldKey: 'datumKreiranja',
            label: 'Datum kreiranja',
            javaFieldType: 'java.lang.String',
            type: 'date',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Ugovori',
            width: 50,
            dbType: 'DATE',
          },
          {
            id: '666666666',
            name: 'datumIsteka',
            fieldKey: 'datumIsteka',
            label: 'Datum isteka',
            javaFieldType: 'java.lang.String',
            type: 'input',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Ugovori',
            width: 50,
            dbType: 'date',
          },
          {
            id: '777777777',
            name: 'stanje',
            fieldKey: 'stanje',
            label: 'Stanje',
            type: 'combo',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Ugovori',
            width: 120,
            dbType: 'VARCHAR(40)',
          },
          {
            id: '888888888',
            name: 'maticniUgovor',
            fieldKey: 'maticniUgovor',
            label: 'Maticni ugovor',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Ugovori',
            width: 120,
            dbType: 'VARCHAR(30)',
          },
        ],
        allFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.Long',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Ugovori',
            width: 10,
            dbType: 'BIGINT',
          },
          {
            id: '222222222',
            name: 'sifraUgovora',
            fieldKey: 'sifraUgovora',
            label: 'Sifra',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Ugovori',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '333333333',
            name: 'kupac',
            fieldKey: 'kupac',
            label: 'Kupac',
            type: 'comboFixed',
            entityType: 'KupciEnum',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Ugovori',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '444444444',
            name: 'plasmanac',
            fieldKey: 'plasmanac',
            label: 'Plasmanac',
            type: 'comboFixed',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Ugovori',
            width: 50,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '555555555',
            name: 'datumKreiranja',
            fieldKey: 'datumKreiranja',
            label: 'Datum kreiranja',
            javaFieldType: 'java.lang.String',
            type: 'date',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Ugovori',
            width: 50,
            dbType: 'DATE',
          },
          {
            id: '666666666',
            name: 'datumIsteka',
            fieldKey: 'datumIsteka',
            label: 'Datum isteka',
            javaFieldType: 'java.lang.String',
            type: 'input',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Ugovori',
            width: 50,
            dbType: 'DATE',
          },
          {
            id: '777777777',
            name: 'stanje',
            fieldKey: 'stanje',
            label: 'Stanje',
            type: 'comboFixed',
            javaFieldType: 'java.lang.String',
            editable: true,
            additable: true,
            mandatory: true,
            path: 'Ugovori',
            width: 120,
            dbType: 'VARCHAR(40)',
          },
          {
            id: '888888888',
            name: 'maticniUgovor',
            fieldKey: 'maticniUgovor',
            label: 'Maticni ugovor',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Ugovori',
            width: 120,
            dbType: 'VARCHAR(30)',
          },
          {
            id: '999999999',
            name: 'brojAneksa',
            fieldKey: 'brojAneksa',
            label: 'Broj aneksa',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'Ugovori',
            width: 120,
            dbType: 'VARCHAR(30)',
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [
                    [
                      '111111111',
                      '222222222',
                      '333333333',
                      '444444444',
                      '555555555',
                      '666666666',
                    ],
                    ['777777777', '888888888', '999999999'],
                  ],
                },
              ],
            },
          ],
          table: [
            '111111111',
            '222222222',
            '333333333',
            '444444444',
            '555555555',
            '666666666',
            '777777777',
            '888888888',
          ],
          lookupTable: [],
        },
        relations: [],
        details: [
          {
            title: 'Korisnici',
            group: 'SifarnikEmisija',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'rbr',
            completerSecondField: 'rbr',
            completerMainAndSecond: true,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            allFields: [],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [[], []],
                    },
                  ],
                },
              ],
              table: [],
              lookupTable: [],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }

  getMediaPlanSettings() {
    return {
      title: 'MediaPlan',
      group: 'MediaPlan',
      deletable: true,
      documentType: 'sifarnik',
      fetchObject: 'basic',
      lazyListSource: 'mainAndSecond',
      formCode: 'MF5',
      idProperty: 'id',
      completerMainField: 'sifra',
      completerSecondField: 'naziv',
      completerMainAndSecond: true,
      name: 'Main',
      type: 'main',
      editable: false,
      additable: false,
      inlineAdding: false,
      inlineEditing: false,
      filterFields: [
        {
          id: '111111111',
          name: 'id',
          fieldKey: 'id',
          label: 'ID',
          type: 'input',
          javaFieldType: 'java.lang.Long',
          editable: false,
          additable: false,
          mandatory: false,
          path: 'MediaPlan',
          width: 10,
          dbType: 'BIGINT',
        },
        {
          id: '222222222',
          name: 'datum',
          fieldKey: 'datum',
          label: 'Datum',
          javaFieldType: 'java.lang.String',
          type: 'date',
          editable: true,
          additable: true,
          mandatory: true,
          path: 'MediaPlan',
          width: 50,
          dbType: 'DATE',
        },
        {
          id: '333333333',
          name: 'vreme',
          fieldKey: 'vreme',
          label: 'Vreme',
          javaFieldType: 'java.lang.String',
          type: 'input',
          editable: true,
          additable: true,
          mandatory: true,
          path: 'MediaPlan',
          width: 50,
          dbType: 'date',
        },
        {
          id: '444444444',
          name: 'ost',
          fieldKey: 'ost',
          label: 'Ost',
          type: 'input',
          javaFieldType: 'java.lang.String',
          editable: true,
          additable: true,
          mandatory: true,
          path: 'MediaPlan',
          width: 120,
          dbType: 'VARCHAR(40)',
        },
      ],
      allFields: [
        {
          id: '111111111',
          name: 'id',
          fieldKey: 'id',
          label: 'ID',
          type: 'input',
          javaFieldType: 'java.lang.Long',
          editable: false,
          additable: false,
          mandatory: false,
          path: 'MediaPlan',
          width: 10,
          dbType: 'BIGINT',
        },
        {
          id: '222222222',
          name: 'datum',
          fieldKey: 'datum',
          label: 'Datum',
          javaFieldType: 'java.lang.String',
          type: 'date',
          editable: true,
          additable: true,
          mandatory: true,
          path: 'MediaPlan',
          width: 50,
          dbType: 'DATE',
        },
        {
          id: '333333333',
          name: 'vreme',
          fieldKey: 'vreme',
          label: 'Vreme',
          javaFieldType: 'java.lang.String',
          type: 'input',
          editable: true,
          additable: true,
          mandatory: true,
          path: 'MediaPlan',
          width: 50,
          dbType: 'date',
        },
        {
          id: '444444444',
          name: 'ost',
          fieldKey: 'ost',
          label: 'Ost',
          type: 'input',
          javaFieldType: 'java.lang.String',
          editable: true,
          additable: true,
          mandatory: true,
          path: 'MediaPlan',
          width: 120,
          dbType: 'VARCHAR(40)',
        },
      ],
      formSettings: {
        header: [
          {
            title: 'Podaci',
            panels: [
              {
                title: 'Panel 1',
                panelVisible: false,
                expanded: true,
                controls: [
                  ['111111111', '222222222', '333333333', '444444444'],
                  [],
                ],
              },
            ],
          },
        ],
        table: ['111111111', '222222222', '333333333', '444444444'],
        lookupTable: [],
      },
      relations: [],
      details: [
        {
          title: 'MediaPlan',
          group: 'MediaPlan',
          deletable: true,
          documentType: 'sifarnik',
          fetchObject: 'basic',
          lazyListSource: 'mainAndSecond',
          completerMainField: 'rbr',
          completerSecondField: 'rbr',
          completerMainAndSecond: true,
          name: 'Main',
          type: 'main',
          editable: true,
          additable: true,
          inlineAdding: true,
          inlineEditing: true,
          allFields: [],
          formSettings: {
            header: [
              {
                title: 'Podaci',
                panels: [
                  {
                    title: 'Panel 1',
                    panelVisible: false,
                    expanded: true,
                    controls: [[], []],
                  },
                ],
              },
            ],
            table: [],
            lookupTable: [],
          },
          relations: [],
          _id: '1932507674',
        },
      ],
      _id: '2075692643',
    };
  }

  getMediaPlanSpotoviSettings() {
    return [
      {
        title: 'Spotovi',
        group: 'Spotovi',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF5',
        idProperty: 'id',
        completerMainField: 'sifra',
        completerSecondField: 'naziv',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: false,
        filterFields: [],
        allFields: [
          {
            id: '111111111',
            name: 'id',
            fieldKey: 'id',
            label: 'ID',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'spotovi',
            width: 5,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '222222222',
            name: 'spot',
            fieldKey: 'spot',
            label: 'Spot',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'spotovi',
            width: 25,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '333333333',
            name: 'duzina',
            fieldKey: 'duzina',
            label: 'Duzina',
            javaFieldType: 'java.lang.String',
            type: 'input',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'spotovi',
            width: 25,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '444444444',
            name: 'brEm',
            fieldKey: 'brEm',
            label: 'brEm',
            javaFieldType: 'java.lang.String',
            type: 'input',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'spotovi',
            width: 10,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '555555555',
            name: 'brSp',
            fieldKey: 'brSp',
            label: 'brSp',
            javaFieldType: 'java.lang.String',
            type: 'input',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'spotovi',
            width: 10,
            dbType: 'VARCHAR(300)',
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [
                    [
                      '111111111',
                      '222222222',
                      '333333333',
                      '444444444',
                      '555555555',
                    ],
                    [],
                  ],
                },
              ],
            },
          ],
          table: [
            '111111111',
            '222222222',
            '333333333',
            '444444444',
            '555555555',
          ],
          lookupTable: [],
        },
        relations: [],
        details: [
          {
            title: 'Spotovi',
            group: 'Spotovi',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'rbr',
            completerSecondField: 'rbr',
            completerMainAndSecond: true,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            allFields: [],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [[], []],
                    },
                  ],
                },
              ],
              table: [],
              lookupTable: [],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }

  getMediaPlanEmisijeSettings() {
    return [
      {
        title: 'Emisije',
        group: 'Emisije',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF5',
        idProperty: 'id',
        completerMainField: 'sifra',
        completerSecondField: 'naziv',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: false,
        filterFields: [],
        allFields: [
          {
            id: '111111111',
            name: 'emisija',
            fieldKey: 'emisija',
            label: 'Emisija',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'emisija',
            width: 25,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '222222222',
            name: 'naslov',
            fieldKey: 'naslov',
            label: 'Naslov',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'emisija',
            width: 25,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '333333333',
            name: 'vreme',
            fieldKey: 'vreme',
            label: 'Vreme',
            javaFieldType: 'java.lang.String',
            type: 'input',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'emisija',
            width: 20,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '444444444',
            name: 'br',
            fieldKey: 'br',
            label: 'Br',
            javaFieldType: 'java.lang.String',
            type: 'input',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'emisija',
            width: 5,
            dbType: 'VARCHAR(300)',
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [
                    ['111111111', '222222222', '333333333', '444444444'],
                    [],
                  ],
                },
              ],
            },
          ],
          table: ['111111111', '222222222', '333333333', '444444444'],
          lookupTable: [],
        },
        relations: [],
        details: [
          {
            title: 'Emisije',
            group: 'Emisije',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'rbr',
            completerSecondField: 'rbr',
            completerMainAndSecond: true,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            allFields: [],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [[], []],
                    },
                  ],
                },
              ],
              table: [],
              lookupTable: [],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }

  getMediaPlanRezervacijeSettings() {
    return [
      {
        title: 'Rezervacije',
        group: 'Rezervacije',
        deletable: true,
        documentType: 'sifarnik',
        fetchObject: 'basic',
        lazyListSource: 'mainAndSecond',
        formCode: 'MF5',
        idProperty: 'id',
        completerMainField: 'sifra',
        completerSecondField: 'naziv',
        completerMainAndSecond: true,
        name: 'Main',
        type: 'main',
        editable: true,
        additable: true,
        inlineAdding: false,
        inlineEditing: false,
        filterFields: [],
        allFields: [
          {
            id: '111111111',
            name: 'datum',
            fieldKey: 'datum',
            label: 'Datum',
            type: 'date',
            javaFieldType: 'java.lang.Date',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'rezervacije',
            width: 30,
            dbType: 'DATE',
          },
          {
            id: '222222222',
            name: 'vreme',
            fieldKey: 'vreme',
            label: 'Vreme',
            type: 'input',
            javaFieldType: 'java.lang.String',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'rezervacije',
            width: 20,
            dbType: 'VARCHAR(300)',
          },
          {
            id: '333333333',
            name: 'ost',
            fieldKey: 'ost',
            label: 'Ost.',
            javaFieldType: 'java.lang.String',
            type: 'input',
            editable: false,
            additable: false,
            mandatory: false,
            path: 'rezervacije',
            width: 10,
            dbType: 'VARCHAR(300)',
          },
        ],
        formSettings: {
          header: [
            {
              title: 'Podaci',
              panels: [
                {
                  title: 'Panel 1',
                  panelVisible: false,
                  expanded: true,
                  controls: [['111111111', '222222222', '333333333'], []],
                },
              ],
            },
          ],
          table: ['111111111', '222222222', '333333333'],
          lookupTable: [],
        },
        relations: [],
        details: [
          {
            title: 'Rezervacije',
            group: 'Rezervacije',
            deletable: true,
            documentType: 'sifarnik',
            fetchObject: 'basic',
            lazyListSource: 'mainAndSecond',
            completerMainField: 'rbr',
            completerSecondField: 'rbr',
            completerMainAndSecond: true,
            name: 'Main',
            type: 'main',
            editable: true,
            additable: true,
            inlineAdding: true,
            inlineEditing: true,
            allFields: [],
            formSettings: {
              header: [
                {
                  title: 'Podaci',
                  panels: [
                    {
                      title: 'Panel 1',
                      panelVisible: false,
                      expanded: true,
                      controls: [[], []],
                    },
                  ],
                },
              ],
              table: [],
              lookupTable: [],
            },
            relations: [],
            _id: '1932507674',
          },
        ],
        _id: '2075692643',
      },
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/services/dummy-settings.service.ts